import { Container } from 'lucide-react';
import { CataloguePanel } from '../../../components/CataloguePanel';
import { useContainerTypes } from '../hooks/use-container-types';
import { buildContainerTypeColumns } from './build-container-type-columns';
import { ContainerTypeFormDrawer } from './ContainerTypeFormDrawer';

/** The container types rate lines and jobs match by code; the two flags drive the job-fit checks (gitaumoses4/chukua#48, #355). */
export function ContainerTypesPanel() {
  const { state, saveError, saving, resetSaveError, create, update, deactivate, reactivate } = useContainerTypes();
  return (
    <CataloguePanel
      noun="container type"
      plural="container types"
      icon={Container}
      emptyDescription="Add the container types your jobs use, such as general purpose, high cube or reefer."
      state={state}
      saveError={saveError}
      saving={saving}
      resetSaveError={resetSaveError}
      create={create}
      update={update}
      deactivate={deactivate}
      reactivate={reactivate}
      buildColumns={buildContainerTypeColumns}
      Drawer={ContainerTypeFormDrawer}
    />
  );
}
